import { render, staticRenderFns } from "./Bando26Fase9.vue?vue&type=template&id=662c4bbc&scoped=true"
import script from "./Bando26Fase9.vue?vue&type=script&lang=js"
export * from "./Bando26Fase9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662c4bbc",
  null
  
)

export default component.exports